import SendAccount from './SendAccount';

export default SendAccount;
